import { render } from "./EventOrganizer.vue?vue&type=template&id=71d62b50"
import script from "./EventOrganizer.vue?vue&type=script&lang=js"
export * from "./EventOrganizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__